// Wraps ANY payroll API call so that, if the server asks for MFA, the user is prompted once and the call is retried.
// Nothing about the call changes unless the server says MFA is needed.
//
//   const res = await callWithStepUp(requireMfa, (extra) => apiPost(url, { ...body, ...extra }));
//   if (!res) { /* user cancelled MFA */ }
//
// `requireMfa` comes from useMFA() (your existing MFAContext). The proof it returns is single-use, issued by the
// server for this exact operation, and is sent in the request body as `stepUpProof`.
export const needsStepUp = (res) =>
  !!res?.data?.results?.mfaRequired && !!res?.data?.results?.stepUpContext;

export async function callWithStepUp(requireMfa, send, { maxPrompts = 2 } = {}) {
  let res = await send({});
  let prompts = 0;
  while (needsStepUp(res) && prompts < maxPrompts) {
    prompts += 1;
    const verified = await requireMfa({
      context: res.data.results.stepUpContext,
      title: "Confirm it's you",
      description: "This payroll action needs extra verification. Enter the 6-digit code from your authenticator app.",
    });
    if (!verified || !verified.stepUpProof) return null; // cancelled or failed
    res = await send({ stepUpProof: verified.stepUpProof });
  }
  return res;
}